import HttpService from "./http-service";
import AsyncPaginatedRequest from "./async-paginated-request";
import {LazyAsyncIter} from "@/iterators";
import {pageMapperBuilder, Paginated} from "@/pagination";
import MissingSubmission from "@/entities/missing-submission";
import {Entity} from "@/entities";


export default class MissingSubmissionService extends HttpService {
    public getAllMissingSubmissionByPeriod(
        params: MissingSubmissionParams
    ): AsyncIterator<Paginated<MissingSubmission>> {
        const asyncReq = new AsyncPaginatedRequest<MissingSubmissionDTO>(
            "get",
            "missing-submission",
            params,
            undefined,
            this.httpClient
        )[Symbol.asyncIterator]();
        return new LazyAsyncIter(asyncReq).map(pageMapperBuilder(MissingSubmissionFromDTO));
    }

    public async getMessage(): Promise<Message> {
        const { data } = await this.httpClient.get('missing-submission/message');
        return data.message;
    }

    public async editMessage(message: string,): Promise<void> {
        await this.httpClient.put('missing-submission/message/editar',{message})
    }

}

export interface MissingSubmissionParams {
    period_year?: number;
    period_month?: number;
    name_or_acronym?: string;
}

export interface MissingSubmissionDTO {
    id: number;
    description: string;
    period_year: number;
    period_month: number;
    entity: Entity;
}

export function MissingSubmissionFromDTO
(dto: MissingSubmissionDTO): MissingSubmission {
    return new MissingSubmission({
        id: dto.id,
        description: dto.description,
        period_year: dto.period_year,
        period_month: dto.period_month,
        entity: dto.entity,
    });
}

interface Message {
    message:string
}
